export default function FormMainContent(props: { children: React.ReactNode }) {
  const { children } = props;

  return (
    <div className="col-9 overflow-hidden">
      <div className="card-body p-0">{children}</div>
    </div>
  );
}
